import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg';
import './LegalPage.scss';

const LegalLayout = ({ title, intro, sections = [], lastReviewed, cta }) => {
    const handleNavigation = () => {
        window.scrollTo(10, 0);
    };

    const slugify = (value) =>
        value
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)+/g, '');

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} isSecondary={true} />
            <main className="legal-page section-padding">
                <div className="container">
                    <div className="legal-hero">
                        <h1>{title}</h1>
                        {intro && <p className="legal-intro">{intro}</p>}
                        {lastReviewed && <span className="legal-updated">Last updated: {lastReviewed}</span>}
                    </div>

                    <div className="legal-content">
                        {sections.map((section) => {
                            const SectionTag = section.ordered ? 'ol' : 'ul';
                            const listClass =
                                section.ordered ? 'legal-list legal-list__ordered' : 'legal-list legal-list__unordered';

                            return (
                                <section
                                    key={section.id || section.heading}
                                    id={section.id || slugify(section.heading)}
                                    className="legal-section"
                                >
                                    <h2>{section.heading}</h2>
                                    {section.paragraphs?.map((paragraph, idx) => (
                                        <p key={idx}>{paragraph}</p>
                                    ))}
                                    {section.list && section.list.length > 0 && (
                                        <SectionTag className={listClass}>
                                            {section.list.map((item, idx) => (
                                                <li key={idx}>{item}</li>
                                            ))}
                                        </SectionTag>
                                    )}
                                    {section.note && <div className="legal-note">{section.note}</div>}
                                </section>
                            );
                        })}
                    </div>

                    {cta && (
                        <div className="legal-cta-card">
                            <h3>{cta.title}</h3>
                            <p>{cta.description}</p>
                            <div className="legal-cta-actions">
                                <Link
                                    onClick={handleNavigation}
                                    to={cta.primary?.to || '/contact'}
                                    className="theme-btn primary"
                                >
                                    {cta.primary?.label || 'Contact Us'}
                                </Link>
                                {cta.secondary && (
                                    <Link
                                        onClick={handleNavigation}
                                        to={cta.secondary.to}
                                        className="theme-btn secondary"
                                    >
                                        {cta.secondary.label}
                                    </Link>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default LegalLayout;
